import axios from 'axios';
import base64 from 'base-64';
import { jwtDecode } from 'jwt-decode';
import { updateToken } from './UpdateToken';

export async function parsePermissionsFromToken(token) {
    const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID;

    const FINANCE_PERMISSION = 'P001';
    const BIZOPS_PERMISSION = 'P002';
    let permissions = [];

    if (token === null || token === undefined) {
        return permissions;
    }

    // let payload = token.substring(token.indexOf('.')+1,token.lastIndexOf('.'));
    // let decodedPayload = base64.decode(payload);
    // const parsedPayload = JSON.parse(decodedPayload, null, 2)

    // const isFinancePermission = parsedPayload.permissions.includes(FINANCE_PERMISSION);
    // const isBizopsPermission = parsedPayload.permissions.includes(BIZOPS_PERMISSION);

    const parsedPayload = jwtDecode(token);
    if (!('resource_access' in parsedPayload)) {
        return [];
    }
    const resource_access = parsedPayload.resource_access;
    if (!(clientId in resource_access)) {
        return [];
    }

    const isFinancePermission = resource_access[clientId]['roles'].includes(FINANCE_PERMISSION);
    const isBizopsPermission = resource_access[clientId]['roles'].includes(BIZOPS_PERMISSION);
    if (isFinancePermission) permissions.push('finance');
    if (isBizopsPermission) permissions.push('bizops');
    return permissions;
}

export async function validateToken(token) {
    if (token === null || token === undefined) {
        return false;
    }

    try {
        let result = await axios.get(process.env.REACT_APP_OAUTH_MEMBER_DETAIL_URI, {
            headers: {
                Authorization: "Bearer " + token,
            },
        });
    } catch (error) {
        const refreshToken = localStorage.getItem("refresh_token");
        if (refreshToken === null || refreshToken === undefined) {
            return false;
        }
        token = await updateToken(refreshToken);
        if (token === null) {
            return false;
        }
    }

    return true;
}